import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Redirect } from 'react-router-dom';
import { useAuthState } from 'react-firebase-hooks/auth';
import 'firebase/auth';
import { createGlobalStyle } from 'styled-components';
import PullToRefresh from 'pulltorefreshjs';
import Analytics from 'react-router-ga';

import firebase from './firebase';
import FirebaseContext from './firebaseContext';

import { Home } from './views/Home';
import { List } from './views/List';
import { ListNew } from './views/ListNew';
import { ListEdit } from './views/ListEdit';
import { ListDetail } from './views/ListDetail';
import { Schedule } from './views/Schedule';
import { Profile } from './views/Profile';

import { ChangeEmail } from './views/account/ChangeEmail';
import { ChangePhoto } from './views/account/ChangePhoto';
import { ForgotPassword } from './views/account/ForgotPassword';
import { InviteUser } from './views/account/InviteUser';
import { InviteAccept } from './views/account/InviteAccept';
import { ResetPassword } from './views/account/ResetPassword';
import { SignUp } from './views/account/SignUp';
import { LoginUser } from './views/account/Login';

import { Wrapper } from './components/Wrapper';
import { VersionCheck } from './components/VersionCheck';

import * as serviceWorker from './serviceWorker';

const GlobalStyle = createGlobalStyle`
  body {
    font-family: sans-serif;
    --theme-primary-color: white;
    --theme-secondary-color: black;
    background: var(--theme-primary-color);
    color: var(--theme-secondary-color);
    transition: all 100ms ease-in;
  }
`;

PullToRefresh.init({
  mainElement: 'body',
  onRefresh() {
    window.location.reload(true);
    serviceWorker.unregister();
  }
});

const checkDarkMode = async () => {
  const darkMode = await JSON.parse(localStorage.getItem('darkMode'));

  const swapStyle = (color1 = 'white', color2 = 'black') => {
    document
      .querySelector('body')
      .style.setProperty('--theme-primary-color', color1);
    document
      .querySelector('body')
      .style.setProperty('--theme-secondary-color', color2);
  };

  // eslint-disable-next-line
  darkMode ? swapStyle('black', 'white') : null;
};

checkDarkMode();

const PrivateRoute = ({ component: Component, ...rest }) => {
  const { user } = useAuthState(firebase.auth());

  return (
    <Route
      {...rest}
      render={props =>
        user && user ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: props.location }
            }}
          />
        )
      }
    />
  );
};

function App() {
  return (
    <FirebaseContext.Provider value={firebase}>
      <GlobalStyle />
      <VersionCheck version="0.1.1" />
      <Router>
        <Analytics id="UA-140633221-1">
          <Wrapper>
            <PrivateRoute path="/" exact component={Home} />
            <PrivateRoute path="/list" exact component={List} />
            <PrivateRoute path="/list/new" exact component={ListNew} />
            <PrivateRoute path="/list/edit/:id" exact component={ListEdit} />
            <PrivateRoute path="/list/view/:id" exact component={ListDetail} />
            <PrivateRoute path="/schedule" exact component={Schedule} />
            <PrivateRoute path="/profile" exact component={Profile} />
            {/* Account info */}
            <PrivateRoute
              path="/account/reset/password"
              exact
              component={ResetPassword}
            />
            <PrivateRoute
              path="/account/reset/email"
              exact
              component={ChangeEmail}
            />
            <PrivateRoute
              path="/account/reset/photo"
              exact
              component={ChangePhoto}
            />
            <Route path="/invite" exact component={InviteUser} />
            <Route
              path="/invite-accept/:inviteid"
              exact
              component={InviteAccept}
            />
            <Route path="/signup" exact component={SignUp} />
            <Route path="/login" exact component={LoginUser} />
            <Route path="/forgot" exact component={ForgotPassword} />
          </Wrapper>
        </Analytics>
      </Router>
    </FirebaseContext.Provider>
  );
}

const rootElement = document.getElementById('root');
ReactDOM.render(<App />, rootElement);

serviceWorker.register({
  updateViaCache: 'none',
  skipWaiting: true
});
